import { Token, Vault, addressEqual } from 'nftx.js';
import { SwapState } from './types';

const getRedeemableCollections = ({
  vaults,
  buyItems,
  filterController,
  sellType,
  sellToken,
  sellVaultId,
}: {
  vaults:
    | Pick<Vault, 'id' | 'vaultId' | 'asset' | 'totalHoldings' | 'prices'>[]
    | undefined;
} & Pick<
  SwapState,
  'filterController' | 'sellType' | 'sellToken' | 'buyItems' | 'sellVaultId'
>) => {
  // const buyVaultIds = [...new Set(buyItems.map((x) => x.vaultId))];
  const collections: Record<
    string,
    Token & { vaultIds: string[]; totalHoldings: number }
  > = {};

  vaults?.forEach((vault) => {
    // don't bother with empty vaults that have nothing to redeem
    if (vault.totalHoldings === 0 || vault.prices?.[0]?.redeem?.price == null) {
      return;
    }
    // If selling ETH you can buy from any collection
    // If selling vToken you can only buy from that vault
    if (
      filterController === 'sell' &&
      sellType === 'vTOKEN' &&
      sellToken &&
      !addressEqual(sellToken, vault.id)
    ) {
      return;
    }
    // If selling NFTs you can only buy from the same vault
    if (
      filterController === 'sell' &&
      sellType === 'NFT' &&
      sellVaultId &&
      sellVaultId !== vault.vaultId
    ) {
      return;
    }

    let collection = collections[vault.asset.id];

    if (!collection) {
      collection = collections[vault.asset.id] = {
        ...vault.asset,
        vaultIds: [],
        totalHoldings: 0,
      };
    }

    collection.vaultIds.push(vault.vaultId);
    collection.totalHoldings += vault.totalHoldings;
  });

  return Object.values(collections);
};

export default getRedeemableCollections;
